import React, { FunctionComponent } from "react";
import { TextField as MUITextField } from "@material-ui/core";
import NumberFormat, { NumberFormatValues } from "react-number-format";
import { commonStyles } from "Theme";
import clsx from "clsx";
export interface Props {
  label: string;
  value?: number;
  onChange: (year?: number) => void;
  error?: boolean;
  className?: string;
}

export const DayField: FunctionComponent<Props> = (props) => {
  const commonClasses = commonStyles();

  const validation = (value: NumberFormatValues): boolean => {
    const day = value.floatValue;

    return day === undefined || (day >= 1 && day <= 31);
  };

  return (
    <NumberFormat
      value={props.value}
      allowNegative={false}
      decimalScale={0}
      allowLeadingZeros={false}
      customInput={MUITextField}
      variant="outlined"
      onValueChange={(values) => {
        props.onChange(values.floatValue);
      }}
      className={clsx(commonClasses.field, props.className)}
      onFocus={(event: any) => event.target.select()}
      isAllowed={validation}
      placeholder={props.label}
      error={props.error}
    />
  );
};

export default DayField;
